/**
 * Shared types for the video decode pipeline.
 *
 * SampleInfo holds demuxed sample metadata + encoded data for a single video frame.
 * DecoderState tracks the lifecycle of the VideoFrameDecoder.
 */

export interface SampleInfo {
  /** Raw encoded sample data (independent copy via slice(0)) */
  data: Uint8Array;
  /** true = keyframe (IDR/RAP) */
  isSync: boolean;
  /** Composition timestamp in microseconds (CTS-based, display order) */
  timestamp: number;
  /** Duration in microseconds */
  duration: number;
  /** Position in CTS-sorted display order (= frame index) */
  displayIndex: number;
}

export enum DecoderState {
  Idle = 'idle',
  Loading = 'loading',
  Ready = 'ready',
  Decoding = 'decoding',
  Error = 'error',
}
